import script from "./allocateOrderBlack.vue?vue&type=script&setup=true&lang=ts"
export * from "./allocateOrderBlack.vue?vue&type=script&setup=true&lang=ts"

import "./allocateOrderBlack.vue?vue&type=style&index=0&id=01fcc514&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01fcc514"]])

export default __exports__